import { apiClient } from './apiClient';

export const demoService = {
  /**
   * Fetch root demo agents for the landing page
   */
  listAgents: async () => {
    return await apiClient.get('/demo/agents');
  },

  /**
   * Start a demo session
   * @param {Object} data `{ mode: 'web', demoAgentId }` for browser WebRTC, or `{ phone, demoAgentId }` for PSTN (legacy)
   */
  startCall: async (data) => {
    return await apiClient.post('/demo/start', data);
  }
};
